module.exports = __webpack_public_path__ + "img/2016.daa233cd.png";